import { ref } from "vue";

import { Level, RenderAs } from "qrcode.vue";

import { Vetlla } from "./types/vetlla.ts";
import { getUploadPath } from "./helpers";
import html2canvas from "html2canvas";

export default function useQr(baseUrl: string) {
  const obertQrVal = ref("");
  const tancatQrVal = ref("");
  const qrLevel = ref<Level>("M");
  const qrRenderAs = ref<RenderAs>("canvas");
  const obertQrClassName = ref("qr-obert-vetlla-canvas");
  const tancatQrClassName = ref("qr-tancat-vetlla-canvas");

  const setQrVals = (idVetlla: Vetlla["Id"]) => {
    obertQrVal.value = baseUrl + getUploadPath("vetlla", idVetlla, true);
    tancatQrVal.value = baseUrl + getUploadPath("vetlla", idVetlla);
  };

  const downloadQr = (containerClassName: string, nombreDifunto: string) => {
    const element = document.querySelector(`.${containerClassName}`) as HTMLElement;

    html2canvas(element, {
      backgroundColor: "#ffffff",
      scale: 2,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `qr-${nombreDifunto}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    }).catch((err) => {
      console.error("Error generant imatge del QR:", err);
    });
  };

  return {
    obertQrVal,
    tancatQrVal,
    qrLevel,
    qrRenderAs,
    obertQrClassName,
    tancatQrClassName,
    setQrVals,
    downloadQr,
  };
}